export default __webpack_public_path__ + "static/media/Protect-your-employees.af361398.svg";